module.exports = __webpack_public_path__ + "images/vector/app/web/src/assets/dropdown arrow-fcf2a854.svg";


//////////////////
// WEBPACK FOOTER
// ./app/web/src/assets/dropdown arrow.svg
// module id = ./app/web/src/assets/dropdown arrow.svg
// module chunks = 0